import {changeEvent, dispatchCustomEvent, fireChangeEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {updatePriceElements} from "../../../../../../../webpack/modules-optimized/product-list";
import {previewOption} from "../../../../../../../webpack/modules-optimized/product";
import {getPriceFormat} from "../../../../../../../webpack/modules-optimized/price-format";


changeEvent('#product-list-page .product-configuration-frame[data-option-type="selectable"] input[name="frame"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-frame');
    let input = configurationMain.querySelector('input[name="option-frame"]');

    container.querySelectorAll('.frame-selectable.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    previewOption(container, previewElement);
    input.value = element.value;
    updateSizesAvailability(element);
    updatePriceElements(container);
    updateSizesPrices(element);
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});

changeEvent('#product-list-page .product-configuration-size[data-option-type="selectable"] input[name="size"]', true, function(element) {
    updateFramesAvailability(element);
});

function updateSizesPrices(frame)
{
    let sizesContainer = isDesktop() ? frame.closest('.product').querySelector('.product-configuration-size') : document.querySelector('#product-list-page .offcanvas.product-configuration-size');
    let frameSizes = JSON.parse(frame.dataset.sizes || '[]');
    let sizes = sizesContainer.querySelectorAll('input[name="size"]');

    sizes.forEach(function (size) {
        let sizePrice = size.dataset.price;
        let width = Math.min(size.dataset.width, size.dataset.height);
        let height = Math.max(size.dataset.width, size.dataset.height);
        let decimals = sizePrice.split('.')[1] ? sizePrice.split('.')[1].length : 0;
        let price = parseFloat(size.dataset.price);
        let label = size.nextElementSibling;
        let sizePriceElement = label.querySelector('.size-price');

        frameSizes.forEach(function (frameSize) {
            if (frameSize.width === width && frameSize.height === height) {
                price += parseFloat(frameSize.price);
                price = price.toFixed(decimals);
            }
        });

        sizePriceElement.innerHTML = getPriceFormat(price);
    });
}

function updateSizesAvailability(frame)
{
    let sizesContainer = isDesktop() ? frame.closest('.product').querySelector('.product-configuration-size') : document.querySelector('#product-list-page .offcanvas.product-configuration-size');
    let frameSizes = JSON.parse(frame.dataset.sizes || '[]');
    let sizes = sizesContainer.querySelectorAll('input[name="size"]');

    sizes.forEach(function(size) {
        let width = Math.min(size.dataset.width, size.dataset.height);
        let height = Math.max(size.dataset.width, size.dataset.height);
        let isValidSize = !frameSizes.length;

        frameSizes.forEach(function (frameSize) {
            if (frameSize.width === width && frameSize.height === height) isValidSize = true;
        });

        size.disabled = !isValidSize;
    });
}

function updateFramesAvailability(size)
{
    let sizeContainer = size.closest('.product-configuration');
    let frameContainer = isDesktop() ? sizeContainer.closest('.product').querySelector('.product-configuration-frame') : document.querySelector('#product-list-page .offcanvas.product-configuration-frame');
    let width = Math.min(size.dataset.width, size.dataset.height);
    let height = Math.max(size.dataset.width, size.dataset.height);
    let frames = frameContainer.querySelectorAll('input[name="frame"]');

    frames.forEach(function(frame) {
        let frameSizes = JSON.parse(frame.dataset.sizes || '[]');
        let frameLabel = frame.nextElementSibling;
        let isValidSize = !frameSizes.length;

        frameSizes.forEach(function (frameSize) {
            if (frameSize.width === width && frameSize.height === height) isValidSize = true;
        });

        if (!isValidSize) {
            frame.checked = false;
            frame.disabled = true;
            if (!frameLabel.classList.contains('disabled')) frameLabel.classList.add('disabled');
        } else {
            frame.disabled = false;
            frameLabel.classList.remove('disabled');
        }
    });


    let onlyOneFrameAvailable = frameContainer.querySelectorAll('input[name="frame"]:not(:disabled)').length === 1;
    if (onlyOneFrameAvailable) {
        let frame = frameContainer.querySelector('input[name="poster-frame"]:not(:disabled)');
        frame.checked = true;
        fireChangeEvent(frame, false);
    }
}